const Contact = () => {
  return (
    <>
      <h1 className="font-bold text-2xl m-10 px-10"> Contact</h1>
      <div className="py-3 px-20 text-xl ">Name : Phanishwar Nath</div>
      <div className="py-3 px-20 text-xl ">Contact : (+91) 8582970633</div>
      <div className="py-3 px-20 text-xl ">Email : pknath023@gmail.com</div>
    </>
  );
};

export default Contact;
